export class ScheduledStopPointEditFailed extends Error {}
